<template>
  <div class="content">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>物料管理</el-breadcrumb-item>
            <el-breadcrumb-item>退场统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
      <el-card>
        <!-- 上 -->
        <div style="display: flex;justify-content: space-between;margin-bottom: 8px;width: 100%;">
          <el-form ref="form" :model="search" label-width="80px">
            <el-form-item label="类型" style="margin:0;">
              <el-select v-model="search.type" placeholder="请选择类型" @change="doFilter">
                <el-option label="全部" value=""></el-option>
                <el-option label="供应商" value="1"></el-option>
                <el-option label="生产厂家" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
      <el-card style="margin-top: 10px;height:calc(100% - 100px);">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column align="center" type="index" label="序号" width="66"></el-table-column>
          <el-table-column prop="exitName" label="供应单位"></el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type=='1'">供应商</span>
              <span v-else>生产厂家</span>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="进场时间">
          </el-table-column>
          <el-table-column prop="operationDate" label="退场时间">
          </el-table-column>
          <el-table-column label="退场原因">
            <template slot-scope="scope">
              <span>{{scope.row.exitWhy}}</span>
            </template>
          </el-table-column>
          <el-table-column label="退场人">
            <template slot-scope="scope">
              <span>{{scope.row.operationName}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="handle" label="操作">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" size="small">编辑</el-button>
              <el-button @click="exitFun(scope.row)" type="danger" size="small">退场</el-button>
              <el-dialog title="退场" :visible.sync="exitDialogFormVisible" width="30%" center>
                <el-form label-position="left" label-width="80px" :model="exitFormData">
                  <el-form-item label="退场单位">
                    <el-input v-model="exitFormData.exitName"></el-input>
                  </el-form-item>
                  <el-form-item label="退场原因">
                    <el-input type="textarea" :rows="2" v-model="exitFormData.exitWhy"></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="exitDialogFormVisible = false">取 消</el-button>
                  <el-button type="primary" @click="saveExitForm">确 定</el-button>
                </div>
              </el-dialog>
            </template>
          </el-table-column> -->
        </el-table>

      </el-card>
    </el-main>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalItems"
    ></el-pagination>
  </div>
</template>
<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
  
  export default {
    data() {
      return {
        search: {  //查询
          type: '',
        },
        tableData: [],//列表
        //弹出框
        dialogFormVisible: false,
        dialogTitle:'',
        addForm:{
          id:'',
          groupId:'',
          userType:'',
          name:'',
          type:'1',
          secondInterview:'',
          createBy:'',
        },
        exitDialogFormVisible: false,
        //分页
        dataText:'数据加载中...',
        currentPage:1,
        pageSize:10,
        totalItems:0,
        //弹出框
        exitFormData:{
          id:'',
          exitName:'',
          exitWhy:'',
          operationId:'', //处理人
          type:''
        },
      }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getData()
    },
    methods: {
      handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getData()
        },
        // 监控当前页码
        currentChangePage() {
            this.getData()
        },
        //查询
        doFilter(){
            this.currentPage = 1
            this.getData()
        },
        //获取数据
        getData(){
          var that = this
          myHttp.getMatProviderPage({
            pageNum:this.currentPage,
            pageSize:this.pageSize,
            groupId:this.groupId,
            userType:util.session.get('roleId'),
            type:this.search.type,
            exitMaterial:'1'
          }).then(function(resp){
            if(resp.data.code=='200'){
              var list = resp.data.data.pageInfo.list||[]
              for(var i=0;i<list.length;i++){
                list[i].index = (i+1)+(that.currentPage-1)*that.pageSize
              }
              that.tableData = list
              that.totalItems = resp.data.data.pageInfo.total
              if(list.length==0){
                that.dataText = '暂无数据'
              }
            }else{
              that.dataText = '暂无数据'
            }
          })
      },
      
      //保存退场信息
      saveExitForm(row) {
        this.exitDialogFormVisible = false
        var that = this
        myHttp.exitUnit(this.exitFormData).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success("添加成功");
            that.exitDialogFormVisible = false;
            that.getData();
          }else{
            that.$message.error(resp.data.msg);
          }
        })
      },

      //添加
      addFun(){
        this.dialogFormVisible = true
        this.dialogTitle = '添加'
        this.addForm.id=''
        this.addForm.groupId = this.groupId
        this.addForm.userType = util.session.get('roleId')
        this.addForm.name = ''
        this.addForm.secondInterview = ''
        this.addForm.type = '1'
      },
      //编辑
      handleClick(row) {
        this.dialogFormVisible = true
        this.dialogTitle = '编辑'
        this.addForm.id=row.id
        this.addForm.groupId = this.groupId
        this.addForm.userType = util.session.get('roleId')
        this.addForm.name = row.type=='1'?row.supplierName:row.manufacturerName
        this.addForm.secondInterview = row.secondInterview
        this.addForm.type = row.type
      },
      //保存
      saveData() {
        if(this.addForm.type=='1'){
          this.addForm.supplierName = this.addForm.name
        }else{
          this.addForm.manufacturerName = this.addForm.name
        }
        this.addForm.createBy = util.session.get('user').id
        var that = this
        if(this.addForm.id==""){
          myHttp.addMatProvider(this.addForm).then(function(resp){
            if(resp.data.code=="200"){
                that.$message.success("添加成功");
                that.dialogFormVisible = false;
                that.currentPage = 1;
                that.getData();
            }else{
                that.$message.error(resp.data.msg);
            }
          },function(){});
        }else{
          myHttp.updateMatProvider(this.addForm).then(function(resp){
          if(resp.data.code=="200"){
              that.$message.success("修改成功");
              that.dialogFormVisible = false;
              that.getData();
          }else{
              that.$message.error(resp.data.msg);
          }
          },function(){});
        }
      },

      //退场
      exitFun(row){
        this.exitDialogFormVisible = true
        this.exitFormData.id = row.id
        this.exitFormData.type = row.type
        if(row.type=='1'){
          this.exitFormData.exitName = row.supplierName
        }else{
          this.exitFormData.exitName = row.manufacturerName
        }
        this.exitFormData.operationId = util.session.get('user').id
      },
    }
  }
</script>
<style scoped>
  .content>>>.el-dialog__body {
    padding: 25px 50px;
  }
</style>